import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '爱漫画上的韩国漫画是否无删减？',
    answer: '是的，爱漫画坚持提供无删减原版韩国漫画内容。我们深知读者对原汁原味内容的追求，所有作品均保留完整情节和画面，让您享受最纯正的韩漫阅读体验。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是一种流畅的漫画阅读方式。您无需翻页，只需向下滚动页面即可连续阅读全部内容，体验如同浏览社交媒体般自然流畅。在爱漫画上，您打开任意漫画即可自动进入下拉式阅读模式。',
  },
  {
    question: '爱漫画是否完全免费？',
    answer: '爱漫画致力于为读者提供免费的韩国漫画阅读服务。我们通过合理的广告运营来维持平台发展，确保读者可以免费畅享海量优质韩漫内容。未来如有任何付费功能推出，我们将提前公告并确保用户体验不受影响。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '爱漫画与多家韩国漫画平台合作，每日更新热门连载作品。热门漫画通常保持每周更新，部分作品可实现每日更新。您可以在首页"最近更新"区域查看最新的漫画章节。',
  },
  {
    question: '如何在手机上阅读漫画？',
    answer: '爱漫画采用响应式设计，完美适配手机、平板和电脑端。您无需下载任何应用程序，只需在浏览器中打开爱漫画网站，即可在手机上享受流畅的下拉式韩漫阅读体验，随时随地畅读无删减韩国漫画。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于爱漫画的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                <span className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full transition-all duration-200 ${
                  openIndex === index ? 'bg-primary-500 text-background-50 rotate-180' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}